import React from "react";
import "../styling/styles.css";

export default function Footer() {
    return (
        <div class="footer-custom">
            <nav class="content">
                <a href="https://www.instagram.com/pranavbyakod/"><i class="fab fa-instagram-square"></i> Social</a>
                <a href="mailto: pranavbyakod@gmail.com"><i class="fas fa-envelope"></i> Email</a>
                <a href="https://github.com/pbyakod"><i class="fab fa-github"></i> Github</a>
                <a href="https://www.linkedin.com/in/pranavbyakod/"><i class="fab fa-linkedin"></i> Linkedin</a>
            </nav>
        </div>
    )
}
